module.exports = __webpack_public_path__ + "img/foto-guitarra.8e035bf3.jpg";